export default {"src":"/_next/static/media/apple_pay.d6cd6536.svg","height":16,"width":39,"blurWidth":0,"blurHeight":0};